import { createSlice, current } from "@reduxjs/toolkit";
import * as Act from "./actions";
const initialState = {
  loading: false,
  REQUESTS: [],
  totalCount: 0,
};
const slice = createSlice({
  name: "REQUESTS",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(Act.getRequests.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.getRequests.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      REQUESTS: payload || [],
      totalCount: payload.totalcount || 0,
    }));
    builder.addCase(Act.getRequests.rejected, (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload || "Unknown error",
      REQUESTS: [],
      totalCount: 0,
    }));
   
    // edit token package
    builder.addCase(Act.updateRequest.pending, (start, action) => ({
      ...start,
      loading: true,
    }));
    builder.addCase(
      Act.updateRequest.fulfilled,
      (state, { payload }) => (
        console.log(payload),
        {
          ...state,
          loading: false,
        }
      )
    );
    builder.addCase(Act.updateRequest.rejected, (state, action) => ({
      ...state,
      loading: false,
    }));
    // delete token package
    builder.addCase(Act.deleteRequest.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(Act.deleteRequest.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
    });
    builder.addCase(Act.deleteRequest.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || action.error;
    });
  },
});

export default slice;
